interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const btn =
    "min-w-9 h-9 px-3 rounded-md text-sm font-label transition-colors cursor-pointer flex items-center justify-center";

  return (
    <nav className="flex items-center justify-center flex-wrap gap-2 mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btn} border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btn} ${
            p === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btn} border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}